import { ViewMode } from '@common/models/view-mode';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';
import gitVersionInfo from '../../git-version-info.json';
import packageJson from '../../package.json';

const serverUrl = `${window.origin}/be`;
const apiUrl = `${serverUrl}/api`;

export const environment = {
    name: 'base',
    serverUrl,
    apiUrl,
    accessToken: 'access_token',
    refreshToken: 'refresh_token',
    title: 'Offer Management System',
    version: packageJson.version,
    gitVersionInfo,
    defaultLanguage: 'en',

    settings: {
        header: {
            logo: '/assets/img/logo.svg',
            logoSmall: '/assets/img/logo-small.png',
            welcomeMessage: 'Welcome to',
            themeColor: 'dark',
            environmentColor: '#fff'
        },
        input: {
            multi: false,
            time: true,
            codelist: {
                take: 100
            },
            fileDownloadUrl: `/query/DownloadAttachment`,
            fileRestrictions: {
                allowedExtensions: [
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.bmp',
                    '.tif',
                    '.doc',
                    '.docx',
                    '.xls',
                    '.xlsx',
                    '.txt',
                    '.pdf',
                    '.xslt'
                ],
                allowedImageExtensions: ['.jpg', '.jpeg', '.png', '.bmp', '.tif']
            },
            dropdown: {
                popupSettings: undefined as PopupSettings
            },
            dateFormat: 'dd/MM/yy',
            timeFormat: 'H:mm:ss',
            /**
             * Creates currency format options with EUR defaults
             * @param options - Optional overrides for the default currency format
             * @returns NumberFormatOptions (default configured for EUR currency with 2 decimal places)
             */
            currencyFormat: (options: Partial<NumberFormatOptions> = {}): NumberFormatOptions => {
                const defaults: NumberFormatOptions = {
                    style: 'currency',
                    currency: 'EUR',
                    currencyDisplay: 'symbol',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };

                options.maximumFractionDigits ??= defaults.maximumFractionDigits;

                return {
                    ...defaults,
                    ...options
                };
            },
            currencySymbol: '€'
        },
        grid: {
            pageable: { buttonCount: 4, info: true, type: 'numeric', pageSizes: [10, 20, 50] },
            pageSize: 20,
            sortable: false,
            sort: [
                {
                    field: 'id',
                    dir: 'asc'
                }
            ],
            filterable: true,
            reorderable: true,
            resizable: true,
            compressedGridValue: '4px',
            autoFitColumns: true,
            messages: {
                pagerItems: 'items',
                pagerItemsPerPage: 'items per page',
                noRecords: 'No records available',
                pagerOf: 'of'
            }
        },
        view: {
            defaultViewMode: ViewMode.view,
            save: {
                redirectToViewMode: ViewMode.view
            }
        },
        list: {
            persistFilter: true,
            rememberFilterState: true
        },
        roundingSettings: {
            price: 3,
            quantity: 3,
            amount: 2,
            taxAmount: 2,
            discountPercentage: 2
        },
        rememberState: {
            actionBar: true,
            darkMode: true,
            filters: true,
            filter: true,
            language: true,
            sidebarPinned: true,
            toggleableFilter: true,
            gridSettings: true
        }
    }
};
